import { Component, OnInit, Inject, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService, SendPasswordResetCodeDto } from '@abp/ng.account.core/proxy';
import { finalize } from 'rxjs/operators';
import { LocalizationService } from '@abp/ng.core';
import { MetroToastService } from '../shared/services/metro-toast.service';

@Component({
  selector: 'app-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordCustomComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  inProgress = false;
  isEmailSent = false;

  private readonly l = inject(LocalizationService);

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private toasterService: MetroToastService
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  protected buildForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(256)]]
    });
  }

  onSubmit() {
    if (this.inProgress || this.forgotPasswordForm.invalid) return;

    this.inProgress = true;
    const { email } = this.forgotPasswordForm.value;

    const request: SendPasswordResetCodeDto = {
      email,
      appName: 'MVC',
      returnUrl: `${window.location.origin}/account/reset-password`
    };

    this.accountService.sendPasswordResetCode(request)
      .pipe(
        finalize(() => (this.inProgress = false))
      )
      .subscribe({
        next: () => {
          this.isEmailSent = true;
          this.toasterService.success(this.l.instant('::PasswordResetSuccessfullyMessage'));
        },
        error: (error) => {
          const message =
            error?.error?.error?.message ||
            error?.error?.error_description ||
            this.l.instant('::PasswordResetEmailError');
          this.toasterService.error(message);
        }
      });
  }

  resetForm() {
    this.isEmailSent = false;
    this.forgotPasswordForm.reset();
    this.buildForm();
  }
}